import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr'; // Alert message using NGX toastr
import { from } from 'rxjs';
import { FireAssessmentService } from 'src/app/services/fire-assessment.service';
import { ActivatedRoute, Router } from '@angular/router'; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalsService } from '../../../modals/modals.service';
import { MatTooltipModule } from '@angular/material/tooltip';


export interface Dropdowns {
  value: number;
  name: string;
}

export var B2Bvalue: boolean;
export var B2Cvalue: boolean;
export var showQ15to17: boolean;

@Component({
  selector: 'app-edit-assessment',
  templateUrl: './edit-assessment.component.html',
  styleUrls: ['./edit-assessment.component.scss']
})
export class EditAssessmentComponent implements OnInit {

  public B2B: boolean = false;
  public B2C: boolean = false;
  public showAll: boolean = false;
  public buttonShow: boolean = true;
  public showBusiness: boolean = false;
  public showProduct: boolean = false;
  public showMarket: boolean = false;
  public showRevenue: boolean = false;
  public showTeam: boolean = false;
  public showQuestion: boolean = true;
  public toggleHigh : boolean = false;
  public toggleMaintain : boolean = false;
  public teamMembersQuanCheck : number;
  public teamMemberHTMLVar: boolean = true;

  toggleB2B() {
    this.B2B = !this.B2B;
    B2Bvalue = this.B2B;
    this.B2C = false;
    B2Cvalue = this.B2C;
    this.buttonShow = !this.buttonShow;
    this.showBusiness = !this.showBusiness;
    this.showAll = !this.showAll;
  }
  toggleB2C() {
    this.B2C = !this.B2C;
    B2Cvalue = this.B2C;
    this.B2B = false;
    B2Bvalue = this.B2B;
    this.buttonShow = !this.buttonShow;
    this.showBusiness = !this.showBusiness;
    this.showAll = !this.showAll;
  }
  /*
  toggleBusinessQuestionHide() {
    this.showQuestion = false;
    this.toggleMaintain = !this.toggleMaintain;
    this.toggleHigh = false;
  }
  toggleBusinessQuestionShow() {
    this.showQuestion = true;
    this.toggleHigh = !this.toggleHigh;
    this.toggleMaintain = false;
  }
  */
  toggleBusiness() {
    this.showBusiness = !this.showBusiness;
  }
  toggleProduct() {
    this.showBusiness = !this.showBusiness;
    this.showProduct = !this.showProduct;
  }
  toggleMarket() {
    this.showProduct = !this.showProduct;
    this.showMarket = !this.showMarket;
  }
  toggleRevenue() {
    this.showMarket = !this.showMarket;
    this.showRevenue = !this.showRevenue;
  }
  toggleTeam() {
    this.showRevenue = !this.showRevenue;
    this.showTeam = !this.showTeam;
  }


  public assessmentForm: FormGroup; // Define  assessment form...in other one at the bottom of this list

  selectedOption: string[] = [];
  selectedMarkEntry: string[] = [];//shows as undefined if remove hey
  //offerMarkEntryCheckBoxCount!: CheckboxCount;
  // offerMarkEntryCheckBoxCount!: number;
  selectedDiff: string[] = [];
  // offerDiffCheckBoxCount!: number;
  selectedpmfCD: string[] = [];
  selectedTeamRole: string[] = [];
  // teamRoleCheckBoxCount!: number;
  selectedTeamUnadv: string[] = [];
  //teamUnadvCheckBoxCount!: number;
  disableSelect = new FormControl(false);

  hasUnitNumber = false;
  busiRegType = [
   {name: 'Not registered'},
   {name: 'Sole proprietor'},
   {name:'Single Member LLC'},
   {name: 'Multi Member LLC'},
   {name: 'S Corp'},
   {name: 'C Corp'},
   {name: 'B Corp'},
  ];
  states = [
    { name: 'Pennsylvania', abbreviation: 'PA' },

  ];
  busiLocation = [
{name: 'City of Pittsburgh'},
{name: 'Allegheny County'},
{name: 'Armstrong County'},
{name: 'Beaver County'},
{name: 'Butler County'},
{name: 'Erie County'},
{name: 'Fayette County'},
{name: 'Warren County'},
{name: 'Washington County'},
{name: 'Westmoreland County'},
{name: 'None of the above'}
];
  contactMethod = ['Email', 'Phone'];
  offerType = [{ name: 'Service' }, { name: 'Product' }];
  offerIndustry = [
    {name: 'Advertising' },
    {name: 'Aerospace/Defense'        },
    {name: 'Air Transport'        },
    {name: 'Apparel'        },
    {name: 'Auto & Truck'        },
    {name: 'Auto Parts'        },
    {name: 'Bank (Money Center)'        },
    {name: 'Banks (Regional)'        },
    {name: 'Beverage (Alcoholic)'        },
    {name: 'Beverage (Soft)'        },
    {name: 'Broadcasting'        },
    {name: 'Brokerage & Investment Banking'        },
    {name: 'Building Materials'        },
    {name: 'Business & Consumer Services'        },
    {name: 'Cable TV'        },
    {name: 'Chemical (Basic)'        },
    {name: 'Chemical (Diversified)'        },
    {name: 'Chemical (Specialty)'        },
    {name: 'Coal & Related Energy'        },
    {name: 'Computer Services'        },
    {name: 'Computers/Peripherals'        },
    {name: 'Construction Supplies'        },
    {name: 'Diversified'        },
    {name: 'Drugs (Biotechnology)'        },
    {name: 'Drugs (Pharmaceutical)'        },
    {name: 'Education'        },
    {name: 'Electrical Equipment'        },
    {name: 'Electronics (Consumer & Office)'        },
    {name: 'Electronics (General)'        },
    {name: 'Engineering/Construction'        },
    {name: 'Entertainment'        },
    {name: 'Environmental & Waste Services'        },
    {name: 'Farming/Agriculture'        },
    {name: 'Financial Svcs. (Non-bank & Insurance)'        },
    {name: 'Food Processing'    },
    {name: 'Food Wholesalers'    },
    {name: 'Furn/Home Furnishings'    },
    {name: 'Green & Renewable Energy'    },
    {name: 'Healthcare Products'    },
    {name: 'Healthcare Support Services'    },
    {name: 'Heathcare Information and Technology'    },
    {name: 'Homebuilding'    },
    {name: 'Hospitals/Healthcare Facilities'    },
    {name: 'Hotel/Gaming'    },
    {name: 'Household Products'    },
    {name: 'Information Services'    },
    {name: 'Insurance (General)'    },
    {name: 'Insurance (Life)'    },
    {name: 'Insurance (Prop/Cas.)'    },
    {name: 'Investments & Asset Management'    },
    {name: 'Machinery'    },
    {name: 'Metals & Mining'    },
    {name: 'Office Equipment & Services'    },
    {name: 'Oil/Gas (Integrated)'    },
    {name: 'Oil/Gas (Production and Exploration)'    },
    {name: 'Oil/Gas Distribution'    },
    {name: 'Oilfield Svcs/Equip.'    },
    {name: 'Packaging & Container'    },
    {name: 'Paper/Forest Products'    },
    {name: 'Power'    },
    {name: 'Precious Metals'    },
    {name: 'Publishing & Newspapers'    },
    {name: 'R.E.I.T.'    },
    {name: 'Real Estate (Development)'    },
    {name: 'Real Estate (General/Diversified)'    },
    {name: 'Real Estate (Operations & Services)'    },
    {name: 'Recreation'    },
    {name: 'Reinsurance'    },
    {name: 'Restaurant & Dining'
    },
    {name: 'Retail (Automotive)'
    },
    {name: 'Retail (Building Supply)'
    },
    {name: 'Retail (Distributors)'
    },
    {name: 'Retail (General)'
    },
    {name: 'Retail (Grocery and Food)'
    },
    {name: 'Retail (Online)'
    },
    {name: 'Retail (Special Lines)'
    },
    {name: 'Rubber& Tires'
    },
    {name: 'Semiconductor'
    },
    {name: 'Semiconductor Equip'
    },
    {name: 'Shipbuilding & Marine'
    },
    {name: 'Shoe'
    },
    {name: 'Software (Entertainment)'
    },
    {name: 'Software (Internet)'
    },
    {name: 'Software (System & Application)'
    },
    {name: 'Steel'
    },
    {name: 'Telecom (Wireless)'
    },
    {name: 'Telecom. Equipment'
    },
    {name: 'Telecom. Services'
    },
    {name: 'Tobacco'
    },
    {name: 'Transportation'
    },
    {name: 'Transportation (Railroads)'
    },
    {name: 'Trucking'
    },
    {name: 'Utility (General)'
    },
    {name: 'Utility (Water)'
    }
  ];
  busiDemographics = [
    { name: 'Women-owned business' },
    { name: 'Minority-owned business' },
    { name: 'Immigrant-owned business' },
    { name: 'English as second language-owned business' },
    { name: 'COVID-19 negatively impacted business' },
    { name: 'None of the above or rather not say' },
  ];
  offerMarkSize: Dropdowns[] = [
    { value: 5, name: 'Excellent' },
    { value: 4, name: 'Good' },
    { value: 3, name: 'Average' },
    { value: 2, name: 'Below Average' },
    { value: 1, name: 'Poor' },
  ];
 /* offerEssential: Dropdowns[] = [
    { value: 1, name: 'Yes' },
    { value: 0, name: 'No' },
    { value: 0, name: 'Not sure' },
  ];*/
  industryNEServing = [
    {name: 'Cooked Food'},
    {name: 'Uncooked Food'},
    {name: 'Liquor'},
  ];
  offerFrequency: Dropdowns[] = [
    { value: 5, name: 'Twice a day or more' },
    { value: 4, name: 'Daily' },
    { value: 3, name: 'Weekly' },
    { value: 2, name: 'Monthly' },
    { value: 1, name: 'Yearly or less' },
  ];
  offerInnovation: Dropdowns[] = [
    { value: 5, name: 'takes everyone in the industry by surprise, and changes how the market operates.' },
    { value: 4, name: 'takes a leap forward in a concept that people have discussed but few have ever produced any real, concrete examples.' },
    { value: 3, name: 'provides a creative non-obvious next step in how the market is trending.' },
    { value: 2, name: 'provides the obvious, next step in how the market is developing; most competitors are also working on similar concepts.' },
    { value: 1, name: 'doesn’t change the market.' },
  ];
  offerImproveLife: Dropdowns[] = [
    { value: 1, name: 'Convenience and ease of process' },
    { value: 1, name: 'Saves time' },
    { value: 1, name: 'Quality of life' },
    { value: 1, name: 'Improvement of health' },
    { value: 1, name: 'Financial stability' },
    { value: 0, name: 'None of the above' },
  ];
  offerDifferentiation: Dropdowns[] = [
    { value: 1, name: 'Quality and Design' },
    { value: 1, name: 'Service and interactions' },
    { value: 1, name: 'Features and functionalities' },
    { value: 1, name: 'Customization' },
    { value: 1, name: 'Pricing' },
    { value: 0, name: 'None of the above' },
  ];
  /*  offerIndustryGrowth = [
      { value: 5, name: 'Exponentially growing' },
      { value: 4, name: 'Moderately growing' },
      { value: 3, name: 'Neither growing or declining' },
      { value: 2, name: 'Moderately declining' },
      { value: 1, name: 'Exponentially declining' },
    ];*/
  offerUrgency: Dropdowns[] = [
    { value: 5, name: 'Extremely high priority' },
    { value: 4, name: 'High priority' },
    { value: 3, name: 'Medium priority' },
    { value: 2, name: 'Low priority' },
    { value: 1, name: 'Not at all priority' },
  ];
  offerMarkEntry: Dropdowns[] = [
    { value: 1, name: 'Tech Challenges' },
    { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
    { value: 1, name: 'Startup costs/Access to capital' },
    { value: 1, name: 'High research and development costs' },
    { value: 1, name: 'Ownership of Raw Materials' },
    { value: 1, name: 'Business Owner Education or Skills' },
    { value: 1, name: 'Personal Network, it`s about who you know' },
    { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
    { value: 1, name: 'Network Effect, Sales' },
    { value: 1, name: 'Brand loyalty' },
    { value: 1, name: 'Access to suppliers and distribution channels' },
  ];
  offerBuyerPower: Dropdowns[] = [
    { value: 1, name: 'My customer will likely leave if my prices are slightly higher than my competition.' },
    { value: 3, name: 'My customer can negotiate my price, but I make the final call.' },
    { value: 5, name: 'My price is firm regardless if my customer threatens to leave.' },
  ];
  offerSupplierPower : Dropdowns[] = [
    { value: 1, name: 'Not at all easy, it would be detrimental' },
    { value: 2, name: 'Slightly easy' },
    { value: 3, name: 'Moderately easy' },
    { value: 4, name: 'Considerably easy' },
    { value: 5, name: 'Extremely easy' },
  ];
  offerSupplierType = [
    { name: 'Manufacturers and vendors (source of the supply chain)' },
    { name: 'Wholesalers and distributors (sell in bulk)' },
    { name: 'Small business owners and trade show reps' },
    { name: 'Agencies' },
    { name: 'Importers' },
    {  name: 'None of the above or I don`t need suppliers' },
  ];

  pmfOverproduction: Dropdowns[] = [//check values
    { value: 5, name: 'Not many' },
    { value: 4, name: 'A few' },
    { value: 3, name: 'A moderate amount' },
    { value: 2, name: 'A considerable amount' },
    { value: 1, name: 'A lot' },
  ];
 /* pmfCompetitorDemand: Dropdowns[] = [
    { value: 5, name: 'Extremely high demand' },
    { value: 4, name: 'Moderately high demand' },
    { value: 3, name: 'Somewhat high demand' },
    { value: 2, name: 'Little to no demand' },
    { value: 1, name: 'Not sure' },
  ];
  pmfCompetitorSatisfaction: Dropdowns[] = [
    { value: 5, name: 'Extremely dissatisfied' },
    { value: 4, name: 'Somewhat dissatisfied' },
    { value: 3, name: 'Somewhat satisfied' },
    { value: 2, name: 'Extremely satisfied' },
    { value: 1, name: 'Not sure' },
  ];*/


  pmfCompetitorDissatisfaction: Dropdowns[] = [ //fix values
    { value: 1, name: 'Quality' },
    { value: 1, name: 'Design' },
    { value: 1, name: 'Service and interactions' },
    { value: 1, name: 'Features and functionalities' },
    { value: 1, name: 'Customization' },
    { value: 1, name: 'Pricing' },
    { value: 0, name: 'None of the above' },
  ];
  marketTargetIndustry = [
    { name: 'Not applicable' },
    { name: 'Accommodation and Food Services' },
    { name: 'Administration & Business Support Services' },
    { name: 'Agriculture, Forestry, Fishing & Hunting' },
    { name: 'Arts, Entertainment & Recreation' },
    { name: 'Construction' },
    { name: 'Educational Services' },
    { name: 'Finance & Insurance' },
    { name: 'Healthcare & Social Assistance' },
    { name: 'Information' },
    { name: 'Manufacturing' },
    { name: 'Professional, Scientific & Technical Services' },
    { name: 'Real Estate, Rental & Leasing' },
    { name: 'Retail Trade' },
    { name: 'Transportation & Warehousing' },
    { name: 'Utilities' },
    { name: 'Wholesale Trade' },
  ];
  marketTargetAge = [
    { name: 'Not applicable' },
    { name: 'All or not sure' },
    { name: '<18'},
    { name: '18-24' },
    { name: '25-34'},
    { name: '35-44' },
    { name: '45-54' },
    { name: '55-64' },
    { name: '>65' },
  ];

  marketTargetEthnicity = [
    { name: 'Not applicable' },
    { name: 'All or not sure' },
    { name: 'Non-Hispanic or Latino' },
    { name: 'White' },
    { name: 'Black or African American' },
    { name: 'Asian or Pacific Islander' },
    { name: 'Other or Multi-Racial' },
    { name: 'Hispanic or Latino' },
  ];
  marketTargetGender = [
    { name: 'Male' },
    { name: 'Female' },
    { name: 'Both' },
    { name: 'Not sure' },
    { name: 'Not applicable' },
  ];

  marketTargetOccupation = [
    { name: 'Not applicable' },
    { name: 'All or not sure' },
    { name: 'Self-employed workers' },
    { name: 'Managers and professionals' },
    { name: 'Tech., sales, and clerical workers' },
    { name: 'Service workers' },
    { name: 'Construction workers & mechanics' },
    { name: 'Operators, fabricators & laborers' },
    { name: 'Retired' },
  ]; // API

  marketTargetLocation = [
    { value: 1, name: 'Local, County or Citywide' },
    { value: 2, name:'Statewide' },
    { value: 3, name:'Regional' },
    { value: 4, name:'National' },
    { value: 5, name:'International' },
  ];
 /* marketTargetIncome = [
    { name: 'Not applicable' },
    { name: 'All or not sure' },
    { name: 'Unemployed' },
    { name: 'Below minimum wage' },
    { name: 'Minimum wage' },
    { name: 'Above minimum wage' },
   
    { name: '$20,000 to $29,999' },
    { name: '$30,000 to $39,999' },
    { name: '$40,000 to $49,999' },
    { name: '$50,000 to $69,999' },
    { name: '$70,000 and over' },
  ];*/
  marketTargetB2BIndustry = [
    {name: 'All'},
    { name: 'Accommodation and Food Services' },
    { name: 'Administration & Business Support Services' },
    { name: 'Agriculture, Forestry, Fishing & Hunting' },
    { name: 'Arts, Entertainment & Recreation' },
    { name: 'Construction' },
    { name: 'Educational Services' },
    { name: 'Finance & Insurance' },
    { name: 'Healthcare & Social Assistance' },
    { name: 'Information' },
    { name: 'Manufacturing' },
    { name: 'Professional, Scientific & Technical Services' },
    { name: 'Real Estate, Rental & Leasing' },
    { name: 'Retail Trade' },
    { name: 'Transportation & Warehousing' },
    { name: 'Utilities' },
    { name: 'Wholesale Trade' },
  ]
/*  marketTargetB2BSize = [
    { name: 'All or not sure' },
    { name: '0-5' },
    { name: '5-10' },
    { name: '10-25' },
    { name: '25-50' },
    { name: '50-100' },
    { name: '100+' },
  ]*/
  marketTargetB2BOccupation = [
    { name: 'Executive officers/Management/Administration' },
    { name: 'Research and development' },
    { name: 'Technical Assistance' },
    { name: 'Operations and production' },
  ]
  marketTargetB2BDecisionMaker = [
    { name: 'Yes' },
    { name: 'No' },
  ]
  revModel = [
    { name: 'Transactional one-time sale' },
    { name: 'Recurring installments or monthly payments' },
    { name: 'Licensing' },
    { name: 'Retail or Wholesale Markups' },
    { name: 'Affiliate or Commission' },
    { name: 'Product is free but services aren’t' },
    { name: 'Interest' },
    { name: 'Donations' },
    { name: 'Pay Per Use' },
  ];
  boolAnswer = [{ name: 'Yes' }, { name: 'No' }];
  teamRole: Dropdowns[] = [
    { value: 1, name: 'Administration and operations' },
    { value: 1, name: 'Research and development, and Production' },
    { value: 1, name: 'Technical Assistance (Trades)' },
    { value: 1, name: 'Sales and marketing' },
    { value: 1, name: 'Accounting and finance' },
    { value: 0, name: 'None of the above' }
  ];
  teamIndustryKnowledge: Dropdowns[] = [
    { value: 5, name: 'Expert' },
    { value: 4, name: 'Advanced' },
    { value: 3, name: 'Competent' },
    { value: 2, name: 'Developing' },
    { value: 1, name: 'Beginner' },
  ];
  teamTime: Dropdowns[] = [
    { value: 1, name: '8 hours or less' },
    { value: 2, name: '9-16 hours' },
    { value: 3, name: '17-24 hours' },
    { value: 4, name: '25-32 hours' },
    { value: 5, name: '33-40 hours or more' },
  ];
  teamNetwork: Dropdowns[] = [
    { value: 5, name: 'A great deal' },
    { value: 4, name: 'Considerably' },
    { value: 3, name: 'Moderately' },
    { value: 2, name: 'Slightly' },
    { value: 1, name: 'Not at all' },
  ];
 /* teamMentors: Dropdowns[] = [
    { value: 1, name: 'Not at all or the team doesn’t have industry mentors' },
    { value: 2, name: 'Slightly' },
    { value: 3, name: 'Moderately' },
    { value: 4, name: 'Considerably' },
    { value: 5, name: 'A great deal' },
  ];*/
  teamTimeManage: Dropdowns[] = [
    { value: 5, name: 'Extremely Well' },
    { value: 4, name: 'Very Well' },
    { value: 3, name: 'Moderately Well' },
    { value: 2, name: 'Slightly Well' },
    { value: 1, name: 'Not at all Well' },
  ];
/*  teamCTA: Dropdowns[] = [
    { value: 5, name: 'Always' },
    { value: 4, name: 'Often' },
    { value: 3, name: 'Sometimes' },
    { value: 2, name: 'Rarely' },
    { value: 1, name: 'Never' },
  ];*/
  teamConflict: Dropdowns[] = [
    { value: 5, name: 'Always or it doesn`t arise' },
    { value: 4, name: 'Often' },
    { value: 3, name: 'Sometimes' },
    { value: 2, name: 'Rarely' },
    { value: 1, name: 'Never' },
  ];
  teamAccountability: Dropdowns[] = [
    { value: 5, name: 'Extremely accountable' },
    { value: 4, name: 'Very accountable' },
    { value: 3, name: 'Moderately accountable' },
    { value: 2, name: 'Slightly accountable' },
    { value: 1, name: 'Not at all accountable' },
  ];
  teamUnproductivity: Dropdowns[] = [
    { value: 1, name: 'Always' },
    { value: 2, name: 'Often' },
    { value: 3, name: 'Sometimes' },
    { value: 4, name: 'Rarely' },
    { value: 5, name: 'Never' },
  ];
  teamPassion: Dropdowns[] = [
    { value: 5, name: 'Extremely passionate' },
    { value: 4, name: 'Very passionate' },
    { value: 3, name: 'Moderately passionate' },
    { value: 2, name: 'Slightly passionate' },
    { value: 1, name: 'Not at all passionate' },
  ];
  teamRisk: Dropdowns[] = [
    { value: 5, name: 'Extremely well' },
    { value: 4, name: 'Very well' },
    { value: 3, name: 'Moderately well' },
    { value: 2, name: 'Slightly well' },
    { value: 1, name: 'Not at all well' },
  ];
  teamOpenness: Dropdowns[] = [
    { value: 5, name: 'Strongly agree' },
    { value: 4, name: 'Moderately agree' },
    { value: 3, name: 'Neither agree or disagree' },
    { value: 2, name: 'Moderately disagree' },
    { value: 1, name: 'Strongly disagree' },
  ];
  teamTrust: Dropdowns[] = [
    { value: 5, name: 'Strongly agree' },
    { value: 4, name: 'Moderately agree' },
    { value: 3, name: 'Neither agree or disagree' },
    { value: 2, name: 'Moderately disagree' },
    { value: 1, name: 'Strongly disagree' },
  ];
  teamRecognition: Dropdowns[] = [
    { value: 5, name: 'Strongly agree' },
    { value: 4, name: 'Moderately agree' },
    { value: 3, name: 'Neither agree or disagree' },
    { value: 2, name: 'Moderately disagree' },
    { value: 1, name: 'Strongly disagree' },
  ];


  teamUnadv: Dropdowns[] = [

  ];

  teamUnadvTemp: Dropdowns[] = [
  ];


  acceptTerms = [
    { name: 'I agree' }
  ];

  //other one...didn't add get and set, or reset in this one
  @ViewChild('iNEQ1') qNE: ElementRef;
  @ViewChild('existingBase') q2: ElementRef;
  @ViewChild('existingProd') q3: ElementRef;

  constructor(
    private fb: FormBuilder,
    public fireAssessment: FireAssessmentService,//data in the other one
    private router: Router,
    public toastr: ToastrService,  // Toastr service for alert message
    public matDialog: MatDialog,
    public modal: ModalsService,
    public tooltip: MatTooltipModule
  ) { }


  // tslint:disable-next-line:typedef
  ngOnInit() {

    this.fireAssessment.readAssessmentsList();  // Call ReadAssessmentsList() before main form is being called
    this.assessmenForm();              // Call assessment form when component is ready
  }

  // tslint:disable-next-line:typedef
  assessmenForm() {
    this.assessmentForm = this.fb.group({
      busiName: [null, Validators.required],
      busiRegType: [null, Validators.required],
      busiFirstName: [null, Validators.required],
      busiLastName: [null, Validators.required],
      busiTelephone: [
        null,
        [Validators.required, Validators.pattern('^[0-9]+$')],
      ],
      busiEmail: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$'),
        ],
      ],
      busiWebsite: null,
      busiStreet: null,
      busiaddress2: null,
      busiCity: null,
      busiState: null,
      busiLocation: null,
      busiZipcode: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(5),
        ]),
      ],
      busiDemographics: [null, Validators.required],
      offerType: [null, Validators.required],
      offerIndustry: [null, Validators.required],
      industryNEServing: null,
      offerFrequency: [null, Validators.required],
      offerInnovation: [null, Validators.required],
      offerDifferentiation: [null, Validators.required],
      selectedDiff: null,
      offerImproveLife: [null, Validators.required],
      offerIndustryGrowth: [null, Validators.required],
      offerMarkEntry: [null, Validators.required],
      offerSupplierPower: [null, Validators.required],
      offerSupplierType: [null, Validators.required],
      offerBuyerPower: [null, Validators.required],
      offerUrgency: [null, Validators.required],
      //marketTargetIndustry: [null, Validators.required],
      marketTargetLocation: [null, Validators.required],
      marketTargetAge: [null, Validators.required],
      marketTargetEthnicity: [null, Validators.required],
      marketTargetGender: [null, Validators.required],
   //   marketTargetHousehold: [null, Validators.required],
      marketTargetOccupation: [null, Validators.required],
     //marketTargetIncome: [null, Validators.required],
      marketTargetB2BIndustry: [null, Validators.required],
    //  marketTargetB2BSize: [null, Validators.required],
      marketTargetB2BOccupation: [null, Validators.required],
      marketTargetB2BDecisionMaker: [null, Validators.required],
      pmfOverproduction: [null, Validators.required],
      pmfCompetitorDissatisfaction: [null, Validators.required],
      selectedpmfCD: null,
      capitalSeeking: [null, Validators.required],
      revModel: [null, Validators.required],
      revInitialCapital: [null, Validators.required],
      revStartingCosts: [null, Validators.required],
      revPerUser: [null, Validators.required],
      revCOGS: [null, Validators.required],
      revFixedCostPerMonth: [null, Validators.required],
      revInitUsers: [null, Validators.required],
      revMonthlyUserGrowth:[null, Validators.required], 
      revMonthlyUserLoss: [null, Validators.required], 
      teamExistingCompany: [null, Validators.required],
      teamExistingCustomerBase: null,
      teamExistingProdListing: null,
      teamLeaderSerialEntrp: [null, Validators.required],
      teamRole: [null, Validators.required],
      teamMembersQuan: [null, Validators.required],
      teamIndustryKnowledge: [null, Validators.required],
      teamTime: [null, Validators.required],
      teamNetwork: [null, Validators.required],
      teamMentors: [null, Validators.required],
      teamUnadv: [null, Validators.required],
      teamTimeManage: [null, Validators.required],
      teamAccountability: [null, Validators.required],
      teamUnproductivity: [null, Validators.required],
      teamPassion: [null, Validators.required],
      teamRisk: [null, Validators.required],
      teamOpenness: [null, Validators.required],
      teamTrust: [null, Validators.required],
      teamRecognition: [null, Validators.required],
      acceptTerms: [null, Validators.required],
    });
  }

  ResetForm() { //add void as in other one?
    this.assessmentForm.reset();
  }




  onSubmit() {
    const assessmentID = this.fireAssessment.createAssessment({...this.assessmentForm.value, b2b: this.B2B, b2c: this.B2C, showQ15to17: this.teamMemberHTMLVar }); // Submit data using CRUD API//take out value? 
    this.ResetForm();
    this.router.navigate(['view-assessments', assessmentID]);
  }

  selectChange(event: { isUserInput: any; }, nm: string) {
    if (event.isUserInput) {
      if (this.selectedOption.find(element => element === nm) === undefined) {
        this.selectedOption.push(nm);
        this.teamUnadv.push({ "value": 1, "name": nm });
      }
      else {
        this.teamUnadvTemp = this.teamUnadv.filter(function (opt) {
          return opt.name !== nm;
        });
        let updated = [];
        for (let el of this.selectedOption) {
          if (el !== nm) {
            updated.push(el);
          }
        }
        this.selectedOption = updated;
        this.teamUnadv = this.teamUnadvTemp;
      }
    }
  }
  /*
    selectMarkEntry(event: { isUserInput: any; }, nm: string) {
  
      if(event.isUserInput){
        // console.log('Hello I just got changed ' + nm );
         console.log(" working event");
       }
    
      let removeEl: string[] = [];
    
     if(this.selectedMarkEntry.find(element => element === nm) === undefined){
      console.log("this is a new selection");
      this.selectedMarkEntry.push(nm);
      this.teamUnadv.push( {"value": 1, "name": nm });
    } else{
      console.log("we are unchecking: " + nm);
      removeEl.push(nm);
      console.log("New to remove: " + removeEl);
  
      //this.teamUnadv = this.teamUnadv.filter(nmCheck);
  
      let updated = [];
    for (let el of this.selectedMarkEntry) {
        if (el !== nm) {
            updated.push(el);
        }
    }
    this.selectedMarkEntry = updated;
    }
  
  
    console.log(" the array updated " + this.selectedMarkEntry)
  
    //console.log("offerMarkEntry count " + this.getCheckBoxCount("offerMarkEntry"));
    }
  */
  diffChange(event: { isUserInput: any; }, nm: string) {

    if (event.isUserInput) {
      // console.log('Hello I just got changed ' + nm );
      console.log(" working event");
    }

    let removeEl: string[] = [];
    // this.selTry.push( { value: 0, name: nm });

    if (this.selectedDiff.find(element => element === nm) === undefined) {
      console.log("this is a new selection");
      this.selectedDiff.push(nm);
      }

    else {
      console.log("we are unchecking: " + nm);
      removeEl.push(nm);
      console.log("New to remove: " + removeEl);

      let updated = [];
      for (let el of this.selectedDiff) {
        if (el !== nm) {
          updated.push(el);
        }
      }
      this.selectedDiff = updated;
        }

    console.log(" the array updated " + this.selectedDiff)

    // console.log("differentiators count" + this.getCheckBoxCount("differentiators"));
  }

  /*teamRoleChange(event: { isUserInput: any; }, nm: string) {

    if(event.isUserInput){
      // console.log('Hello I just got changed ' + nm );
       console.log(" working event");
     }

    let removeEl: string[] = ["hey"];
   // this.selTry.push( { value: 0, name: nm });

   if(this.selectedTeamRole.find(element => element === nm) === undefined){
    console.log("this is a new selection");
    this.selectedTeamRole.push(nm);
  }

  else{
    console.log("we are unchecking: " + nm);
    removeEl.push(nm);
    console.log("New to remove: " + removeEl);

    let updated = [];
  for (let el of this.selectedTeamRole) {
      if (el !== nm) {
          updated.push(el);
      }
  }
  this.selectedTeamRole = updated;
  }


  console.log(" the array updated " + this.selectedTeamRole)

  //console.log("teamRole count" + this.getCheckBoxCount("teamRole"));
  }*/

  teamUnadvChange(event: { isUserInput: any; }, nm: string) {

    if (event.isUserInput) {
      // console.log('Hello I just got changed ' + nm );
      console.log(" working event");
    }

    let removeEl: string[] = [];
    // this.selTry.push( { value: 0, name: nm });

    if (this.selectedTeamUnadv.find(element => element === nm) === undefined) {
      console.log("this is a new selection");
      this.selectedTeamUnadv.push(nm);
    }


    else {
      console.log("we are unchecking: " + nm);
      removeEl.push(nm);
      console.log("New to remove: " + removeEl);

      let updated = [];
      for (let el of this.selectedTeamUnadv) {
        if (el !== nm) {
          updated.push(el);
        }
      }
      this.selectedTeamUnadv = updated;
    }


    console.log(" the array updated " + this.selectedTeamUnadv)

    //console.log("teamUnadv count" + this.getCheckBoxCount("teamUnadv"));
  }

  pmfCDChange(event: { isUserInput: any; }, nm: string) {

    if (event.isUserInput) {
      // console.log('Hello I just got changed ' + nm );
      console.log(" working event");
    }

    let removeEl: string[] = [];
    // this.selTry.push( { value: 0, name: nm });

    if (this.selectedpmfCD.find(element => element === nm) === undefined) {
      console.log("this is a new selection");
      this.selectedpmfCD.push(nm);
    }

    else {
      console.log("we are unchecking: " + nm);
      removeEl.push(nm);
      console.log("New to remove: " + removeEl);

      let updated = [];
      for (let el of this.selectedpmfCD) {
        if (el !== nm) {
          updated.push(el);
        }
      }
      this.selectedpmfCD = updated;
    }


    console.log(" the array updated " + this.selectedpmfCD)

    //console.log("pmfCompDiss count" +  this.getCheckBoxCount("pmfCompetitorDissatisfaction"));

    //console.log("pmfSolve: " + this.pmfSolveNeed());
    //it should call pmfSolve at the end of this function to make sure the function is updated after every change
  }

  handleQ2(event: { isUserInput: any; }, name: string) {
    if (event.isUserInput) {
      if (name === 'Yes') {
        this.q2.nativeElement.style.display = 'block';
      }
      else if (name === 'No') {
        this.q2.nativeElement.style.display = 'none';
        this.q3.nativeElement.style.display = 'none';

      }
    }

  }
  handleQ3(event: { isUserInput: any; }, name: string) {
    if (event.isUserInput) {
      if (name === 'Yes') {
        console.log("yes was selected ");
        this.q3.nativeElement.style.display = 'block';
      }
      else if (name === 'No') {
        this.q3.nativeElement.style.display = 'none';
      }
    }

  }
 
  

  handleNighttimeEconomyQ1(event: { isUserInput: any; }, name: any) {
    if (event.isUserInput) {
      if (name === 'Restaurant & Dining') {
        console.log("Rest was selected ");
        this.qNE.nativeElement.style.display = 'block';
      }
      else if (name != 'Restaurant & Dining') {
        this.qNE.nativeElement.style.display = 'none';

      }
    }

  }

  tabNum = 0;
  nextTab() {
    if(this.tabNum < 5) {
      this.tabNum++;
    }
  }
  prevTab() {
    if(this.tabNum > 0) {
      this.tabNum--;
    }
  }

  hideQ15to17() {
    if(this.teamMembersQuanCheck == 1) {
      this.teamMemberHTMLVar = false;
      showQ15to17 = this.teamMemberHTMLVar;
    } else {
      this.teamMemberHTMLVar = true;
      showQ15to17 = this.teamMemberHTMLVar;
    }
  }






  updateAssessmentForm() {
    this.fireAssessment.UpdateAssessments(this.assessmentForm.value);       // Update student data using CRUD API
    this.toastr.success(this.assessmentForm.controls['busiName'].value + ' updated successfully');   // Show succes message when data is successfully submited
    this.router.navigate(['view-assessments']);               // Navigate to student's list page when student data is updated
  }


}
